import axios from "axios";
import toast from "react-hot-toast";

const axiosReqConfig = async (url, method, values) => {
  try {
    const bearerToken =
      localStorage.getItem("token") || sessionStorage.getItem("token");
    const reqConfig = {
      url: url,
      method: method,
      headers: { Authorization: `Bearer ${bearerToken}` },
      data: values,
    };
    const response = await axios(reqConfig);
    return { ok: true, data: response.data, status: response.status };
  } catch (error) {
    const status = error?.response?.status ?? 0;
    const data = error?.response?.data ?? null;
    const message =
      (typeof data === "object" && data && (data.message || data.error)) ||
      (typeof data === "string" && data.slice(0, 160)) ||
      error?.message ||
      "Request failed";

    if (status) {
      toast.error(`${status} ${message}`);
    } else {
      toast.error("Network error. Please try again.");
    }

    return { ok: false, data, status };
  }
};

export { axiosReqConfig };
